"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pill = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var ui_visually_hidden_1 = require("@hopin-team/ui-visually-hidden");
var react_1 = tslib_1.__importDefault(require("react"));
var close_button_1 = require("./styled/close-button");
var root_1 = require("./styled/root");
var Pill = function (_a) {
    var testID = _a["data-testid"], label = _a.label, className = _a.className, isCapped = _a.isCapped, isRemovable = _a.isRemovable, onRemove = _a.onRemove, _b = _a.removeLabel, removeLabel = _b === void 0 ? 'Remove tag' : _b, __UIScope = _a.__UIScope, id = _a.id;
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: Pill.name,
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    return (react_1.default.createElement(root_1.Root, { className: rootClasses, isRemovable: isRemovable, isCapped: isCapped, "data-testid": testID },
        react_1.default.createElement(ui_visually_hidden_1.VisuallyHidden, null, "Tag:"),
        react_1.default.createElement("span", null, label),
        isRemovable && (react_1.default.createElement(close_button_1.CloseButton, { type: "button", icon: "close", title: removeLabel, onClick: onRemove, id: id, isRound: true, isGhost: true }))));
};
var PillWithSpace = (0, ui_helper_with_space_1.withSpace)(Pill);
exports.Pill = PillWithSpace;
//# sourceMappingURL=pill.js.map